var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStablesFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 898.84 357.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1987.05,
    y1: -164.99,
    x2: 1987.05,
    y2: -185.36,
    gradientTransform: "rotate(-41.69 1433.26 2326.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1974.27,
    y1: -185.36,
    x2: 1974.27,
    y2: -195.91,
    gradientTransform: "rotate(-41.69 1433.26 2326.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ecc8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1972.77,
    y1: -164.99,
    x2: 1972.77,
    y2: -185.36,
    gradientTransform: "rotate(-41.69 1433.26 2326.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1878a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 141.82,
    y1: 90.81,
    x2: 155.56,
    y2: 90.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043e54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1987.05,
    y1: -155.38,
    x2: 1987.05,
    y2: -166.81,
    gradientTransform: "rotate(-41.69 1433.26 2326.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043e54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17628f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 157.24,
    y1: 131.83,
    x2: 157.24,
    y2: 104.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8ecc8d}.cls-7{fill:#043e54}.cls-9{fill:#198aad}.cls-11{fill:#72c494}.cls-14{fill:#0b455e}.cls-15{fill:#51b699}.cls-16{fill:#b6dc8c}.cls-17{fill:#1878a2}.cls-18{fill:#2ca2a4}.cls-19{fill:#17628f}.cls-20{fill:#033342}.cls-21{fill:#9bd08b}.cls-22{fill:#105477}.cls-24{fill:#02252d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 255.36c-5.94 0-11.36-.73-16.25-2.19-4.89-1.46-9.24-3.61-13.03-6.45-3.79-2.83-7.2-6.26-10.22-10.29l12.89-14.67c4.48 6.22 8.94 10.45 13.37 12.69s9.26 3.36 14.47 3.36c2.83 0 5.37-.39 7.61-1.17 2.24-.78 4-1.9 5.28-3.36 1.28-1.46 1.92-3.2 1.92-5.21 0-1.46-.32-2.81-.96-4.05-.64-1.23-1.55-2.33-2.74-3.29-1.19-.96-2.61-1.83-4.25-2.61-1.64-.78-3.47-1.46-5.48-2.06-2.01-.59-4.21-1.07-6.58-1.44-5.12-1.19-9.6-2.63-13.44-4.32-3.84-1.69-7.04-3.79-9.6-6.31-2.56-2.51-4.46-5.37-5.69-8.57-1.23-3.2-1.85-6.81-1.85-10.83s.91-7.93 2.74-11.45c1.83-3.52 4.37-6.56 7.61-9.12 3.24-2.56 6.99-4.53 11.25-5.9s8.75-2.06 13.51-2.06c5.85 0 10.97.66 15.36 1.99 4.39 1.33 8.21 3.22 11.45 5.69 3.24 2.47 5.96 5.49 8.16 9.05l-13.03 12.62c-1.92-2.56-4-4.71-6.24-6.45a24.3 24.3 0 00-7.27-3.91 25.18 25.18 0 00-8.02-1.3c-3.02 0-5.62.39-7.82 1.17-2.2.78-3.91 1.9-5.14 3.36-1.23 1.46-1.85 3.25-1.85 5.35 0 1.65.41 3.11 1.23 4.39.82 1.28 2.01 2.4 3.57 3.36 1.55.96 3.43 1.81 5.62 2.54s4.62 1.37 7.27 1.92c5.03 1.01 9.55 2.33 13.58 3.98 4.02 1.65 7.47 3.63 10.35 5.97 2.88 2.33 5.1 5.07 6.65 8.23 1.55 3.15 2.33 6.7 2.33 10.63 0 6.49-1.56 12.02-4.66 16.59-3.11 4.57-7.4 8.07-12.89 10.49s-11.89 3.63-19.2 3.63zm40.98-56.51v-17.42h47.86v17.42h-47.86zm13.57 55.14v-90.93h19.47v90.93h-19.47zm71.25 1.37c-6.03 0-11.47-1.65-16.32-4.94s-8.69-7.77-11.52-13.44-4.25-12.16-4.25-19.47 1.44-13.78 4.32-19.41c2.88-5.62 6.79-10.06 11.73-13.3s10.56-4.87 16.87-4.87c3.56 0 6.83.53 9.8 1.58 2.97 1.05 5.58 2.49 7.82 4.32s4.13 3.93 5.69 6.31a23.97 23.97 0 013.29 7.68l-4.12-.69v-17.69h19.34v72.55h-19.61v-17.42l4.39-.41c-.73 2.56-1.92 4.98-3.57 7.27-1.65 2.29-3.68 4.32-6.1 6.1-2.42 1.78-5.14 3.2-8.16 4.25-3.02 1.05-6.22 1.58-9.6 1.58zm5.35-16.87c3.65 0 6.86-.87 9.6-2.61 2.74-1.74 4.87-4.18 6.38-7.34s2.26-6.83 2.26-11.04-.76-7.73-2.26-10.83c-1.51-3.11-3.63-5.55-6.38-7.34-2.74-1.78-5.95-2.67-9.6-2.67s-6.7.89-9.39 2.67c-2.7 1.78-4.82 4.23-6.38 7.34-1.56 3.11-2.33 6.72-2.33 10.83s.78 7.89 2.33 11.04c1.55 3.15 3.68 5.6 6.38 7.34 2.7 1.74 5.83 2.61 9.39 2.61zm95.39 16.87c-3.2 0-6.31-.46-9.33-1.37s-5.76-2.17-8.23-3.77c-2.47-1.6-4.53-3.43-6.17-5.49-1.64-2.06-2.7-4.18-3.15-6.38l4.39-1.65-.96 17.01H586.6V152.5h19.47v45.94l-3.7-1.51c.55-2.19 1.6-4.32 3.15-6.38 1.55-2.06 3.52-3.89 5.9-5.49 2.38-1.6 4.98-2.86 7.82-3.77 2.83-.91 5.76-1.37 8.78-1.37 6.31 0 11.93 1.62 16.87 4.87 4.94 3.25 8.85 7.7 11.73 13.37 2.88 5.67 4.32 12.16 4.32 19.47s-1.42 13.81-4.25 19.47c-2.84 5.67-6.7 10.13-11.59 13.37-4.89 3.25-10.45 4.87-16.66 4.87zm-4.66-16.6c3.65 0 6.83-.89 9.53-2.67 2.7-1.78 4.82-4.25 6.38-7.41 1.55-3.15 2.33-6.83 2.33-11.04s-.76-7.77-2.26-10.97c-1.51-3.2-3.63-5.67-6.38-7.41-2.74-1.74-5.95-2.61-9.6-2.61s-6.86.87-9.6 2.61c-2.74 1.74-4.89 4.21-6.45 7.41-1.55 3.2-2.33 6.86-2.33 10.97s.78 7.89 2.33 11.04 3.7 5.62 6.45 7.41c2.74 1.78 5.94 2.67 9.6 2.67zm49.31 15.23V152.5h19.47v101.49h-19.47zm70.92 1.37c-7.87 0-14.72-1.6-20.57-4.8-5.85-3.2-10.42-7.59-13.71-13.17-3.29-5.58-4.94-11.98-4.94-19.2 0-5.58.91-10.7 2.74-15.36s4.39-8.71 7.68-12.14c3.29-3.43 7.2-6.08 11.73-7.95s9.44-2.81 14.74-2.81c4.94 0 9.51.89 13.71 2.67 4.2 1.78 7.84 4.3 10.9 7.54 3.06 3.25 5.42 7.06 7.06 11.45 1.65 4.39 2.38 9.19 2.2 14.4l-.14 6.03h-58.29l-3.15-11.93h45.39l-2.19 2.47v-3.02c-.19-2.47-.98-4.71-2.4-6.72s-3.22-3.57-5.42-4.66c-2.19-1.1-4.66-1.65-7.4-1.65-4.03 0-7.43.78-10.22 2.33-2.79 1.56-4.92 3.84-6.38 6.86-1.46 3.02-2.19 6.67-2.19 10.97s.94 8.18 2.81 11.38c1.87 3.2 4.53 5.69 7.96 7.47 3.43 1.78 7.47 2.67 12.14 2.67 3.2 0 6.12-.5 8.78-1.51 2.65-1 5.49-2.74 8.5-5.21l9.33 13.03a39.556 39.556 0 01-8.78 5.97c-3.2 1.6-6.49 2.81-9.87 3.63-3.38.82-6.72 1.23-10.01 1.23zm67.56 0c-6.77 0-12.78-1.12-18.04-3.36s-9.49-5.32-12.69-9.26l12.07-10.42c2.83 3.02 5.99 5.19 9.46 6.51 3.47 1.33 6.95 1.99 10.42 1.99 1.37 0 2.63-.16 3.77-.48 1.14-.32 2.12-.78 2.95-1.37.82-.59 1.44-1.32 1.85-2.19.41-.87.62-1.8.62-2.81 0-2.01-.82-3.61-2.47-4.8-.92-.46-2.33-1.03-4.25-1.71-1.92-.69-4.39-1.44-7.41-2.26-4.66-1.19-8.62-2.58-11.86-4.18-3.25-1.6-5.83-3.41-7.75-5.42-1.65-1.92-2.9-4-3.77-6.24-.87-2.24-1.3-4.73-1.3-7.47 0-3.29.73-6.28 2.19-8.98s3.5-5.01 6.1-6.93c2.61-1.92 5.6-3.4 8.98-4.46 3.38-1.05 6.95-1.58 10.7-1.58s7.41.46 10.97 1.37c3.56.92 6.88 2.22 9.94 3.91 3.06 1.69 5.74 3.68 8.02 5.97l-10.42 11.52c-1.65-1.55-3.5-2.97-5.55-4.25a30.407 30.407 0 00-6.38-3.02c-2.2-.73-4.16-1.1-5.9-1.1-1.55 0-2.95.14-4.18.41s-2.26.69-3.09 1.23-1.44 1.26-1.85 2.13c-.41.87-.62 1.81-.62 2.81s.25 1.97.75 2.88c.5.92 1.21 1.69 2.12 2.33 1.01.55 2.49 1.19 4.46 1.92 1.96.73 4.64 1.56 8.02 2.47 4.39 1.19 8.11 2.52 11.18 3.98 3.06 1.46 5.51 3.15 7.34 5.07 1.55 1.65 2.7 3.52 3.43 5.62s1.1 4.44 1.1 6.99c0 4.48-1.26 8.48-3.77 12-2.52 3.52-5.97 6.26-10.36 8.23s-9.32 2.95-14.81 2.95z",
    fill: "#154f78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M367.53 138.85v-32.76h13.9c1.93 0 3.69.46 5.27 1.38 1.57.92 2.82 2.18 3.74 3.77.92 1.59 1.38 3.39 1.38 5.38s-.46 3.85-1.38 5.48c-.92 1.62-2.17 2.91-3.74 3.86-1.58.95-3.33 1.43-5.27 1.43h-6.88v11.47h-7.02zm6.92-17.79h6.18c.75 0 1.42-.19 2.01-.58.59-.39 1.07-.91 1.43-1.57.36-.66.54-1.4.54-2.25s-.18-1.58-.54-2.22c-.36-.64-.84-1.14-1.43-1.5-.59-.36-1.26-.54-2.01-.54h-6.18v8.66zm18.12 17.79l12.82-32.76h6.27l12.78 32.76h-7.21l-6.6-17.64c-.19-.5-.41-1.14-.68-1.92-.27-.78-.54-1.61-.82-2.48s-.55-1.71-.8-2.5c-.25-.8-.44-1.46-.56-1.99l1.26-.05c-.19.72-.4 1.46-.63 2.22-.23.77-.47 1.54-.72 2.34s-.52 1.57-.79 2.32c-.28.75-.55 1.48-.8 2.2l-6.6 17.5h-6.93zm5.94-6.88l2.29-5.66h15.02l2.34 5.66H398.5zm31.92 6.88v-32.76h7.02v26.44h14.84v6.32h-21.86zm43.34.47c-2.4 0-4.62-.42-6.64-1.26a16.18 16.18 0 01-5.31-3.53c-1.51-1.51-2.68-3.31-3.49-5.38s-1.22-4.33-1.22-6.76.4-4.72 1.22-6.76c.81-2.04 1.97-3.83 3.49-5.36 1.51-1.53 3.28-2.71 5.31-3.56 2.03-.84 4.24-1.26 6.64-1.26s4.66.42 6.67 1.26c2.01.84 3.78 2.03 5.29 3.56 1.51 1.53 2.67 3.32 3.49 5.38.81 2.06 1.22 4.31 1.22 6.74s-.41 4.68-1.22 6.74c-.81 2.06-1.97 3.85-3.49 5.38-1.51 1.53-3.28 2.71-5.29 3.56-2.01.84-4.24 1.26-6.67 1.26zm0-6.65c1.37 0 2.64-.25 3.81-.75s2.18-1.22 3.02-2.15 1.5-2.03 1.99-3.28c.48-1.25.73-2.62.73-4.12s-.24-2.87-.73-4.12c-.48-1.25-1.15-2.33-1.99-3.25-.84-.92-1.85-1.64-3.02-2.15s-2.44-.77-3.81-.77-2.64.26-3.79.77-2.17 1.23-3.04 2.15c-.88.92-1.54 2.01-1.99 3.25-.45 1.25-.68 2.62-.68 4.12s.23 2.87.68 4.12a9.534 9.534 0 001.99 3.28 8.97 8.97 0 003.04 2.15c1.15.5 2.42.75 3.79.75zm24.43 6.18v-32.76h6.41l11.93 19.42-4.21-.05 12.07-19.38h6.13v32.76h-6.88v-11.23c0-2.81.07-5.34.21-7.58.14-2.25.38-4.48.73-6.69l.84 2.2-9.59 14.88h-3.09l-9.41-14.79.79-2.29c.34 2.09.59 4.24.73 6.44s.21 4.81.21 7.84v11.23h-6.88zm41.42 0v-6.04h5.47v-20.69h-5.47v-6.04h17.97v6.04h-5.47v20.69h5.47v6.04h-17.97zm27.05 0v-32.76h6.27l18.11 24.48h-1.31c-.12-.97-.23-1.91-.33-2.83-.09-.92-.18-1.86-.26-2.81-.08-.95-.14-1.93-.19-2.95-.05-1.01-.09-2.09-.12-3.23-.03-1.14-.05-2.38-.05-3.72v-8.94h6.88v32.76h-6.37l-18.49-24.71 1.78.05c.16 1.62.29 3 .4 4.14.11 1.14.19 2.13.26 2.97.06.84.12 1.58.16 2.2.05.62.08 1.22.09 1.78s.02 1.15.02 1.78v11.79h-6.88zm53.45.47c-2.4 0-4.62-.42-6.65-1.26a16.18 16.18 0 01-5.31-3.53c-1.51-1.51-2.68-3.31-3.49-5.38s-1.22-4.33-1.22-6.76.4-4.72 1.22-6.76c.81-2.04 1.97-3.83 3.49-5.36 1.51-1.53 3.28-2.71 5.31-3.56 2.03-.84 4.24-1.26 6.65-1.26s4.66.42 6.67 1.26c2.01.84 3.78 2.03 5.29 3.56 1.51 1.53 2.68 3.32 3.49 5.38s1.22 4.31 1.22 6.74-.41 4.68-1.22 6.74c-.81 2.06-1.97 3.85-3.49 5.38-1.51 1.53-3.28 2.71-5.29 3.56-2.01.84-4.23 1.26-6.67 1.26zm0-6.65c1.37 0 2.64-.25 3.81-.75s2.18-1.22 3.02-2.15c.84-.94 1.51-2.03 1.99-3.28s.72-2.62.72-4.12-.24-2.87-.72-4.12-1.15-2.33-1.99-3.25c-.84-.92-1.85-1.64-3.02-2.15s-2.44-.77-3.81-.77-2.64.26-3.79.77-2.17 1.23-3.04 2.15c-.87.92-1.54 2.01-1.99 3.25-.45 1.25-.68 2.62-.68 4.12s.23 2.87.68 4.12c.45 1.25 1.12 2.34 1.99 3.28s1.89 1.65 3.04 2.15c1.15.5 2.42.75 3.79.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.41 298.35H67.3v-81.72h64.71c-48.4 0-73.66-33.48-73.66-76.65s34.5-74.62 76.9-74.62h103.08v81.5h-41.18c11.59 0 71.25 11.45 71.25 74.16 0 55.09-32.62 77.33-82.99 77.33z",
    fill: "#d9e694"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M210.95 214.42l-4.11 18.03-11.41 8.9-6.67-2.84 14.2-7.89 7.99-16.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.23 186.24l-24.79 38.91 28.52-9.13-3.73-29.78z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M99.92 160.01l-3.61 4.86 2.23 22.93.9-23.59.48-4.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M99.44 164.21l7.84 3.8-4.04 1.81 5.77 17.73-10.47.25.9-23.59z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient)",
    d: "M171.01 86.95l7.57 20.54 21.01-21.14-28.58.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M199.59 86.35l5.25 10.62 2.92-3.23-8.17-7.39z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M201.12 84.3l-1.53 2.05 8.17 7.39-6.64-9.44z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M201.12 84.3l-25.95-1.72 24.42 3.77 1.53-2.05z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M175.17 82.58l-4.16 4.37 28.58-.6-24.42-3.77z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.82 81.9l10.19 5.05 4.16-4.37-14.35-.68z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-2)",
    d: "M160.82 81.9l-5.26 5.48 15.45-.43-10.19-5.05z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M165.85 78.72l-5.03 3.18 14.35.68-9.32-3.86z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M162.22 81.02l-12.34.71 6.07 3.54 2.98-1.39 1.89-1.98 1.4-.88z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M149.88 81.73l12.34-.71 3.63-2.3-15.97 3.01zm-8.06 6.69l13.74-1.04 3.37-3.5-17.11 4.54z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M155.56 87.38l10.95 16.82 4.5-17.25-15.45.43z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-3)",
    d: "M171.01 86.95l-4.5 17.25 12.07 3.29-7.57-20.54z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-4)",
    d: "M141.82 88.42l11.12 5.82 2.62-6.86-13.74 1.04z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-5)",
    d: "M199.59 86.35l-21.01 21.14 26.26-10.52-5.25-10.62z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M178.58 107.49l-12.07-3.29 5.08 9.43 6.99-6.14z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.56 87.38l-2.62 6.86 13.57 9.96-10.95-16.82z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M152.94 94.24l-30.18 29.58 25.2-7.1 4.98-22.48z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M152.94 94.24l13.57 9.96-18.55 12.52 4.98-22.48z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.51 104.2l-3.18 27.63 8.26-18.2-5.08-9.43z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-6)",
    d: "M166.51 104.2l-18.55 12.52 15.37 15.11 3.18-27.63z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M139.36 131.22l-16.6-7.4-13.85 12.63 30.45-5.23z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.36 131.22l-23.65 30.98-6.8-25.75 30.45-5.23z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M108.91 136.45l-3.4 19.19 10.2 6.56-6.8-25.75z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M105.51 155.64l-14.33-7.53 16.52-2.19-2.19 9.72z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M107.7 145.92l-17.74-3.88 1.22 6.07 16.52-2.19z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.96 142.04l-3.4 8.74 4.62-2.67-1.22-6.07z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M86.56 150.78l2.19 21.62 3.4-4.37-.97-19.92-4.62 2.67z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M92.15 168.03l4.37.97-1.21-18.95-4.13-1.94.97 19.92z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M92.15 168.03l-3.4 4.37 6.07 10.93-.97-12.63 8.99 2.67-6.32-4.37-4.37-.97z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M94.82 183.33l9.23 3.16-1.21-13.12-8.99-2.67.97 12.63z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M99.92 160.01l11.56-.58 4.23 2.77-16.27 2.01.48-4.2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M99.44 164.21l18.89 9.41-2.97-6.93.35-4.49-16.27 2.01z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M98.54 187.8l10.06 8.74.41-8.99-10.47.25z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.01 187.55l7.34 2.81.17 11.62-7.92-5.44.41-8.99z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M147.96 116.72l20.68 39.98-5.31-24.87-15.37-15.11z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M168.64 156.7l-20.2-3.94-.48-36.04 20.68 39.98z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148.44 152.76l29.79 33.48-9.59-29.54-20.2-3.94z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M139.36 131.22l8.6-14.5-25.2 7.1 16.6 7.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.36 131.22l9.08 21.54-.48-36.04-8.6 14.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6d38b",
    d: "M139.36 131.22l-23.65 30.98 32.73-9.44-9.08-21.54z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M118.33 173.62l30.11-20.86-32.73 9.44-.35 4.49 2.97 6.93z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.33 173.62l9.63 16.73 1.76-19.29-11.39 2.56z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.72 171.06l18.72-18.3-4.68 17.04-14.04 1.26z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M143.76 169.8l4.68-17.04 29.79 33.48-34.47-16.44z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.23 186.24l-29.11 2 7.82 32.12 21.29-34.12z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M168.64 156.7l32.94 34.42-23.35-4.88-9.59-29.54z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M149.12 188.24l-5.36-18.44 34.47 16.44-29.11 2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M149.12 188.24l-21.16 2.11 1.76-19.29 19.4 17.18z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.12 188.24l-21.16 2.11 24.52 11.68-3.36-13.79z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M178.23 186.24l32.72 28.18-9.37-23.3-23.35-4.88z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M178.23 186.24l3.73 29.78 28.99-1.6-32.72-28.18z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M181.96 216.02l21 14.6 7.99-16.2-28.99 1.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M181.96 216.02l-15.06 23.96-13.46-14.83 28.52-9.13z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M181.96 216.02l-15.06 23.96 36.06-9.36-21-14.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M153.44 225.15l7.3 30.12 6.16-15.29-13.46-14.83z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.9 239.98l7.76 6.39-13.92 8.9 6.16-15.29z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M166.9 239.98l36.06-9.36-28.3 15.75-7.76-6.39z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M174.66 246.37l2.51 22.6-16.43-13.7 13.92-8.9z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.74 255.27l2.05 15.75 14.38-2.05-16.43-13.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M177.17 268.97l-28.53 21.22-4.79-.91 18.94-18.26 14.38-2.05z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M162.79 271.02l-28.52 18.94 7.76 3.88 1.82-4.56 18.94-18.26z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.27 289.96l-7.54 8.39h15.5l-.2-4.51-7.76-3.88z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M192.6 240.15l11.74 28.33-23.49-25.55 7.91-4.42 3.84 1.64z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M192.6 240.15l2.83 1.2 1.44-1.13 16.95 22.93-9.48 5.33-11.74-28.33z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M204.34 268.48l-12.41 25.36 21.89-30.69-9.48 5.33z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M199.86 263.6l-7.93 30.24 12.41-25.36-4.48-4.88z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M199.86 263.6l-15.24 27.41 7.31 2.83 7.93-30.24z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M184.62 291.01l-5.45 7.34h11.8l.96-4.51-7.31-2.83zM235.14 230l-6.86-.83-17.33-14.75L235.14 230z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M210.95 214.42l-4.93 10 12.4 15.98-7.47-25.98z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M210.95 214.42l17.33 14.75-6.8 4.47-10.53-19.22z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M221.48 233.64l-10.53-19.22 7.47 25.98 3.06-6.76z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.48 233.64l6.11 30.01.69-34.48-6.8 4.47z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M228.28 229.17l13.41 30.07-3.93 16.79-9.48-46.86z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M221.48 233.64l-3.06 6.76 9.17 23.25-6.11-30.01z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M235.14 230l6.55 29.24-13.41-30.07 6.86.83z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M228.28 229.17l-.69 34.48 10.17 12.38-9.48-46.86z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M118.33 173.62l30.11-20.86-18.72 18.3-11.39 2.56zm11.39-2.56l14.04-1.26 5.36 18.44-19.4-17.18z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M173.32 193.95l-24.2-5.71 3.36 13.79 20.84-8.08z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M178.23 186.24l-29.11 2 24.2 5.71 4.91-7.71z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M152.48 202.03l-24.52-11.68 27.69 24.74-3.17-13.06z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStablesFull);
export default __webpack_public_path__ + "static/media/stables-full.aa423c016228452b6dfc34337df7a73f.svg";
export { ForwardRef as ReactComponent };